import { Button, ButtonGroup, useTheme } from "@mui/material";

interface SelectionOptionsItemProps {
    key: string;
    value: string;
}

interface SelectionOptionsProps {
    id?: string;
    items: SelectionOptionsItemProps[];
    value?: string;
    onValueChange?: (value: string) => void;
}

export const SelectionOptions = ({
    id, items, value, onValueChange
}: SelectionOptionsProps) => {

    const theme = useTheme();

    const handleClick = (item: SelectionOptionsItemProps) => {
        if (item.key !== value && onValueChange) {
            onValueChange(item.key);
        }
    }

    return (
        <ButtonGroup id={id} sx={{
            height: '40px',
            border: `1px solid ${theme.palette.grey[600]}`,
            backgroundColor: theme.palette.common.white
        }}>
            {items.map((item) => {
                return (
                    <Button
                        id={id ? `${id}-${item.key.toLowerCase()}` : ''}
                        key={item.key}
                        variant={item.key === value ? 'contained' : 'outlined'}
                        onClick={() => { handleClick(item); }}
                        sx={{
                            color: item.key === value ? theme.palette.common.black : theme.palette.action.disabled,
                            cursor: item.key === value ? 'default' : undefined,
                            ":hover": {
                                color: theme.palette.common.black,
                                backgroundColor: item.key === value ? theme.palette.primary.main : theme.palette.action.hover,
                            }
                        }}
                    >
                        {item.value}
                    </Button>
                )
            })}
        </ButtonGroup>
    )
}
